import { Group } from '@components/layout';
import { type SxProps } from '@mui/material';
import type { PropsWithChildren } from 'react';

export const ResourceCard = ({
  sx,
  children,
  onClick,
  flex = false,
}: PropsWithChildren<{ sx?: SxProps; onClick?: () => void; flex?: boolean }>) => {
  return (
    <Group
      gap={2}
      flexWrap="wrap"
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        p: 3,
        backgroundColor: 'background.paperCard',
        color: 'foreground.paperCard.default',
        width: '100%',
        minWidth: '200px',
        '&:hover': {
          borderColor: 'foreground.paperCard.light',
        },
        flex: flex ? '0 1 auto' : undefined,
        minHeight: flex ? 0 : undefined,
        overflow: flex ? 'hidden' : undefined,
        flexDirection: flex ? 'column' : 'row',
        alignItems: flex ? 'stretch' : 'center',
        justifyContent: flex ? 'flex-start' : 'space-between',
        ...sx,
      }}
      onClick={onClick}
    >
      {children}
    </Group>
  );
};
